const DataDeliveryIllustration = () => (
  <svg
    width="379"
    height="281"
    viewBox="0 0 379 281"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="text-fg-secondary opacity-40"
  >
    <path
      d="M165.638 117.547L168.1 121.24V158.167L165.638 161.86C165.638 166.104 159.672 170.174 149.053 173.175C138.435 176.176 124.032 177.862 109.015 177.862C93.9979 177.862 79.5958 176.176 68.977 173.175C58.3582 170.174 52.3926 166.104 52.3926 161.86L49.9307 158.167V121.24L52.3926 117.547"
      stroke="currentColor"
    />
    <path
      d="M165.638 161.859L168.1 165.552V203.711L165.638 207.404C165.638 211.648 159.672 215.718 149.053 218.719C138.435 221.72 124.032 223.406 109.015 223.406C93.9979 223.406 79.5958 221.72 68.977 218.719C58.3582 215.718 52.3926 211.648 52.3926 207.404L49.9307 203.711V165.552L52.3926 161.859"
      stroke="currentColor"
    />
    <path
      d="M52.3923 72.002C52.3923 80.8397 77.7431 88.0041 109.015 88.0041C140.287 88.0041 165.638 80.8416 165.638 72.0039M52.3923 72.002C52.3923 63.1644 77.7431 56 109.015 56C140.287 56 165.638 63.1662 165.638 72.0039M52.3923 72.002L52.3926 72.0039L49.9307 75.6967V113.855L52.3926 117.548C52.3926 121.792 58.3582 125.862 68.977 128.863C79.5958 131.864 93.9979 133.55 109.015 133.55C124.032 133.55 138.435 131.864 149.053 128.863C159.672 125.862 165.638 121.792 165.638 117.548L168.1 113.855V75.6967L165.638 72.0039"
      stroke="currentColor"
    />
    <circle
      cx="20"
      cy="20"
      r="19.5"
      transform="matrix(-1 0 0 1 309.961 59)"
      stroke="currentColor"
    />
    <circle
      cx="20"
      cy="20"
      r="19.5"
      transform="matrix(-1 0 0 1 309.961 120.547)"
      stroke="currentColor"
    />
    <circle
      cx="0.274503"
      cy="0.274503"
      r="0.267641"
      transform="matrix(-1 0 0 1 290.445 140.273)"
      stroke="currentColor"
      strokeWidth="0.0137252"
    />
    <g clipPath="url(#clip0_305_878)">
      <path
        d="M295.304 129.348C295.698 129.348 296.086 129.451 296.428 129.648C296.769 129.846 297.053 130.13 297.25 130.472L302.38 139.356C302.577 139.698 302.682 140.086 302.682 140.48C302.682 140.875 302.577 141.263 302.38 141.604L297.25 150.489C297.053 150.831 296.769 151.114 296.428 151.312C296.086 151.509 295.698 151.613 295.304 151.613H285.044C284.65 151.613 284.262 151.509 283.921 151.312C283.579 151.114 283.295 150.831 283.098 150.489L277.968 141.604C277.771 141.262 277.667 140.875 277.667 140.48C277.667 140.086 277.771 139.698 277.968 139.356L283.098 130.472C283.295 130.13 283.579 129.846 283.921 129.648C284.262 129.451 284.65 129.348 285.044 129.348H295.304ZM290.175 135.945C287.671 135.945 285.642 137.975 285.642 140.479C285.642 142.982 287.672 145.011 290.175 145.011C291.23 145.011 292.2 144.649 292.971 144.044L294.746 145.819C294.786 145.859 294.84 145.881 294.896 145.881C294.953 145.881 295.007 145.859 295.047 145.819L295.517 145.35C295.556 145.31 295.578 145.255 295.578 145.199C295.578 145.143 295.556 145.09 295.517 145.05L293.74 143.273C294.345 142.503 294.707 141.534 294.707 140.479C294.707 137.975 292.678 135.946 290.175 135.945ZM290.175 137.039C292.074 137.039 293.614 138.579 293.614 140.479C293.614 142.378 292.074 143.918 290.175 143.918C288.275 143.918 286.736 142.378 286.735 140.479C286.735 138.579 288.275 137.039 290.175 137.039ZM289.719 139.113V142.906C289.864 142.933 290.013 142.949 290.166 142.949C290.305 142.949 290.442 142.935 290.575 142.913V139.113H289.719ZM288.021 140.301V141.71C288.23 142.068 288.524 142.369 288.877 142.585V140.301H288.021ZM291.495 140.887V142.56C291.854 142.331 292.149 142.016 292.352 141.642V140.887H291.495Z"
        fill="currentColor"
      />
    </g>
    <circle
      cx="20"
      cy="20"
      r="19.5"
      transform="matrix(-1 0 0 1 309.961 182.094)"
      stroke="currentColor"
    />
    <path
      d="M261.892 201.934C222.292 201.934 222.292 180.934 181.892 180.934"
      stroke="currentColor"
      strokeDasharray="4.92 3.69"
    />
    <path
      d="M261.892 78.9336C222.292 78.9336 222.292 100.934 181.892 100.934"
      stroke="currentColor"
      strokeDasharray="4.92 3.69"
    />
    <line
      y1="-0.5"
      x2="81"
      y2="-0.5"
      transform="matrix(-1 0 0 1 261.892 139.934)"
      stroke="currentColor"
      strokeDasharray="4.92 3.69"
    />
    <defs>
      <clipPath id="clip0_305_878">
        <rect
          width="25.6523"
          height="25.6523"
          fill="white"
          transform="translate(277.348 127.723)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default DataDeliveryIllustration
